module.exports = __webpack_public_path__ + "img/icon-close-w.7ab7a943.svg";